<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>营销管理</el-breadcrumb-item>
      <el-breadcrumb-item>留言板</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox" v-if="index==1">
      <el-row class="conentRow">
        <div>
          <el-col class="conentCol">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col class="conentColSele">
            <el-select
              v-model="data.state"
              placeholder="状态"
              clearable
            >
              <el-option
                v-for="item in typeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="conentBtn" style="width: auto">
            <el-button type="primary" @click="btnsClick">查询</el-button>
          </el-col>
        </div>
        <div class="addBtns">
          <!-- <div>
            <img src="@/assets/add.png" alt="">
            <span>添加信息</span>
          </div> -->
        </div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
        :row-class-name="tableRowClassName"
        :cell-style="cellStyle"
      >
        <el-table-column prop="createtime" label="留言时间"></el-table-column>
        <el-table-column  label="状态">
          <template  slot-scope="scope">
            <div class="cursor" v-if="scope.row.state=='1'">
              <img src="@/images/scenic/dh.png" alt />
              .
              <span style="margin-left:9px">未读</span>
            </div>
            <div class="cursor"  v-if="scope.row.state=='2'" >
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">已读</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="联系电话"></el-table-column>
        <el-table-column prop="content" label="留言内容">
          <template slot-scope="scope">
             <span class="contents">{{scope.row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="Detail(scope.row)"
              >详情查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ data.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="data.page_size"
          :current-page="data.page"
          @current-change="currenchange"
        ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="留言详情"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="740px"
      center
    >
      <div class="info_dialogs">
        <el-form   :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="80px">
          <div class="flexs">
            <el-form-item label="姓名:"> 
              <el-input disabled placeholder="" v-model="username"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:"> 
              <el-input disabled placeholder="" v-model="mobile"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="内容:">
            <el-input disabled type="textarea" v-model="content"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog_btns">
          <div @click="addProHandleClose">返回</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getMessageList , messageDetail}  from '@/request/scenic.js'
import {Message, MessageBox } from 'element-ui'
export default {
  data() {
    return {
      labelPosition: "right",
      addProDialogVisible: false,
      index: 1,
      data: {
        token: window.sessionStorage.getItem("Token"),
        starttime:'',
        endtime:'',
        state:'',
        page:'1',
        page_size:8
      },
      name: "",
      typeArr:[
        {
          value:'1',
          label:'未读'
        },
        {
          value:'2',
          label:'已读'
        },
      ],
      value1:'',
      tableData:[],
      total:0,
      username:'',
      mobile:'',
      content:''
    };
  },
  created(){
    this.getList()
  },
  methods: {
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    btnsClick(){
      if(this.value1){
        this.data.starttime = this.value1[0]
        this.data.endtime = this.value1[1]
      }else{
        this.data.starttime = ''
        this.data.endtime = ''
      }
      this.data.page = 1
      this.getList()
    },
    Detail(row){
      let data = {
        token: window.sessionStorage.getItem("Token"),
        id:row.id
      }
      messageDetail(data).then(res=>{
        if(res.data.rcode==200){
          this.username = res.data.result.username
          this.mobile = res.data.result.mobile
          this.content = res.data.result.content
          this.addProDialogVisible = true
        }
      })
    },
    getList(){
      getMessageList(this.data).then(res=>{
        if(res.data.rcode=='200'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    addProHandleClose() {
      this.addProDialogVisible = false;
    },
    tabClick(e){
      if(this.index==e){
        return false
      }
      this.index = e
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex,
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.dialog_btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  >div{
    width: 10rem;
    height: 4rem;
    color: #fff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    background: #246deb;
  }
}
.info_dialogs {
  padding: 2rem;
  box-sizing: border-box;
  border-top: 1px solid #e5e5ea;
  ::v-deep .el-select{
    width: 100%;
  }
  .flexs{
    display: flex;
    justify-content: space-between;
    ::v-deep .el-input{
      width: 24rem;
    }
  }
  ::v-deep .el-textarea{
    height: 24rem;
  }
  ::v-deep .el-textarea__inner{
    height: 100% !important;
    resize: none; 
    width: 100%;
  }

}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .conentCol {
        width: 32rem;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
        /deep/.el-input {
          width: 100%;
        }
      }
      .conentColSele {
        margin-left: 30px;
        margin-bottom: 10px;
        width: 32rem;
        position: relative;
        /deep/.el-select {
          width: 100%;
        }
      }
      .conentBtn {
        margin-bottom: 10px;
        margin-left: 20px;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}
.info_tabs {
  display: flex;
  align-items: center;
  margin-top: 2rem;
  > div {
    margin-right: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 11.6rem;
    height: 4rem;
    border-radius: 0.4rem;
    color: #fff;
    font-size: 1.4rem;
    background: #d9d9d9;
    cursor: pointer;
  }
  .tabs_active {
    background: #246deb;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.addBtns{
  >div{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12rem;
    height: 4rem;
    border-radius: 0.4rem;
    border: 1px solid #246DEB;
    color: #246DEB;
    cursor: pointer;
    img{
      width: 1.4rem;
      height: 1.4rem;
      margin-right: 1rem;
    }
  }
}
.contents{
  white-space: nowrap;   //不换行
 overflow: hidden;       //超出部分隐藏
 text-overflow: ellipsis;    //文本溢出显示省略号
}
</style>